import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import { Cancel01Icon } from '@hugeicons-pro/core-stroke-rounded';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {

  @Input() isMobile: boolean;
  @Input() mobileOpen: boolean;
  @Output() closed = new EventEmitter<void>();

  Cancel01Icon = Cancel01Icon;

  constructor(public router: Router) {
  }

  close(): void {
    this.closed.emit();
  }

  onBackdropClick(): void {
    if (this.isMobile) {
      this.close();
    }
  }

  onLinkClick(): void {
    if (this.isMobile) {
      this.close();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isMobile && this.mobileOpen) {
      this.close();
    }
  }
}
